import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ListIcon = (props: IconProps) => (
  <Icon width="18px" height="18px" viewBox="0 0 18 18" {...props}>
    <path d="M3 11.25h12v-1.5H3v1.5Zm0 3h12v-1.5H3v1.5Zm0-6h12v-1.5H3v1.5Zm0-4.5v1.5h12v-1.5H3Z" />
  </Icon>
);

export default memo(ListIcon);
